export enum SysParam {

  ToDoMaxLanes = "todo.maxlanes",
  ConnectPubNubSubscribeKey = "connect.pubnub.subscribeKey",
  ConnectPubNubPublishKey = "connect.pubnub.publishKey",
  SupportPubNubSubscribeKey = "support.pubnub.subscribeKey",
  SupportPubNubPublishKey = "support.pubnub.publishKey",
}
